const VERSION: string = '0.1.7-prod.88'
export default VERSION;
